import React, { useState, useEffect } from 'react';
import '../../styles/Modals.css';

const InputModal = ({ isOpen, onClose, onSubmit, title, placeholder, label, type = 'text' }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setValue('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim()) {
      onSubmit(value.trim());
      setValue('');
      onClose();
    }
  };

  const handleCancel = () => {
    setValue('');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px', padding: '18px' }}>
        <h2 style={{ margin: '0 0 14px 0', fontSize: '15px', fontWeight: 500, color: '#334155', letterSpacing: '0.01em' }}>
          {title}
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            {label && (
              <label
                style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '12px',
                  fontWeight: 400,
                  color: '#64748b',
                }}
              >
                {label}
              </label>
            )}
            <input
              type={type}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              autoFocus
              style={{
                width: '100%',
                boxSizing: 'border-box',
                padding: '8px 10px',
                border: '1px solid #d0d5dd',
                borderRadius: '7px',
                fontSize: '12px',
                fontWeight: 400,
                color: '#101828',
                outline: 'none',
                background: '#fff',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#94a3b8';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#d0d5dd';
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={handleCancel}
              style={{
                flex: '0 0 auto',
                padding: '8px 16px',
                border: '1px solid #d0d5dd',
                background: 'white',
                borderRadius: '7px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 400,
                color: '#344054',
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!value.trim()}
              style={{
                flex: '0 0 auto',
                padding: '8px 16px',
                border: 'none',
                borderRadius: '7px',
                cursor: value.trim() ? 'pointer' : 'not-allowed',
                fontSize: '12px',
                fontWeight: 400,
                color: value.trim() ? 'white' : '#94a3b8',
                background: value.trim()
                  ? 'linear-gradient(180deg, #1a202c 0%, #2d3748 100%)'
                  : '#f1f5f9',
              }}
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InputModal;

